import { toasterState } from "Components/common/toaster";
import DriverMaster from "Components/driver/Driver";
import {
  AUTH_SCOPES_CALENDAR
} from "Static/constant";
import userDetail from "Stores/userDetail";
import InboxUtils from "Utils/InboxUtils";
import PaywallUtils from "Utils/PaywallUtils";
import Utils from "Utils/utils";
import { gmailMessagePopupState } from "../ConnectInbox/GmailMessagePopup";
import reconnectSequencePopupState from "../ConnectInbox/ReconnectSequencePopupState";
import connectedInboxStore from "../ConnectInbox/store";

const connectedEmailUtils = {};

const handleGoogleOauthCbk = async (cbkCode = "", inboxId = "", connectedInbox = {}) => {
  const { noOfInboxesUsed = 0 } = userDetail?.userFeatureFlag || {};

  switch (cbkCode) {
    case "200":
      connectedInboxStore.setLoading(true);
      userDetail.setUserFeatureFlag({
        ...userDetail.userFeatureFlag,
        noOfInboxesUsed: noOfInboxesUsed + 1
      });
      await connectedInboxStore.getAccountDetails(true);
      window.postMessage({ type: "CONNECT_INBOX_SUCCESS" }, "*");
      Utils.getOnboardingData();
      Utils.trackOnboardingMixpanel("account_connected");
      if (inboxId && Object.keys(connectedInbox).length > 0) {
        await reconnectSequencePopupState.getAllCampaignSequences(inboxId, connectedInbox);
      }
      break;
    case "400":
      gmailMessagePopupState.setPopupValues({
        title: "Insufficient Permission",
        subTitle: `Unable to connect your Google account with SalesIntel due to insufficient permissions.
      Please retry connecting by enabling all the required permissions on the consent screen 
      <br>(Please refer to the video below)`
      });
      gmailMessagePopupState.setShowPopup(true);
      break;
    case "409":
      gmailMessagePopupState.setPopupValues({
        title: "Connection Failed",
        subTitle: `Unable to connect your Google account with SalesIntel as its already connected to a different SalesIntel account. Please try re-connecting a different Google account`,
        additionalLink: `<a class="errorLink" href="https://support.salesgear.io/en/articles/5660382-why-do-i-get-the-connection-failed-error-when-i-try-to-connect-my-gmail-with-salesgear" target="_blank" rel="noopener noreferrer"><span>Why do I get the connection failed error?</span><i class="fa fa-external-link openInNewTabIcon" aria-hidden="true"></i></a>`
      });
      gmailMessagePopupState.setShowPopup(true);
      break;
    case "412":
      gmailMessagePopupState.setPopupValues({
        title: "Connection Failed",
        subTitle: `Please connect the same email account`
      });
      gmailMessagePopupState.setShowPopup(true);
      break;
    case "413":
      toasterState.setToastMsg(
        `Oops! You cannot connect personal email addresses.`,
        "fail"
      );
      break;
    case "500":
    default:
      toasterState.setToastMsg(
        "Something went wrong. Please try again later",
        "fail"
      );
  }
};

const closeGmailMessagePopup = () => {
  gmailMessagePopupState.setPopupValues({});
  gmailMessagePopupState.setShowPopup(false);
};

connectedEmailUtils.openGmailConnectPopup = () => {
  if (InboxUtils.connectInboxAllowed()) {
    DriverMaster.killDriver();
    gmailMessagePopupState.setConnectBtnAction(
      connectedEmailUtils.openGoogleAuth
    );
    // gmailMessagePopupState.setPopupValues({
    //   title: `Connect your Google account with Salesgear`,
    //   subTitle: ""
    // });
    gmailMessagePopupState.setShowPopup(true);
  } else {
    upgradeMulitpleInbox();
  }
};

connectedEmailUtils.openGoogleAuth = async () => {
  const { calendarEnabled = false } = userDetail?.userInfo || {};
  const { calendarIntegrationEnabled = false } =
    userDetail?.userFeatureFlag || {};
  const {
    gmailClientId = "",
    gmailRedirectUrl = "",
    gmailScopes = ""
  } = connectedInboxStore.oAuthConfigs || {};

  closeGmailMessagePopup();
  let gmailAuthScope =
    calendarEnabled && calendarIntegrationEnabled
      ? AUTH_SCOPES_CALENDAR
      : gmailScopes;
  const authUrl =
    "https://accounts.google.com/o/oauth2/auth?client_id=" +
    gmailClientId +
    "&scope=" +
    gmailAuthScope +
    "&access_type=offline&response_type=code&redirect_uri=" +
    gmailRedirectUrl +
    "&prompt=select_account" +
    "&hd=*";
  const w = 600;
  const h = 800;
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`;
  window.open(authUrl, "SalesIntel", params);
  const oauthCbk = async ev => {
    if (ev?.data?.type === "GOOGLE_CONNECT_INBOX") {
      handleGoogleOauthCbk(ev?.data?.code?.toString(), ev?.data?.inboxId, ev?.data?.connectedInbox);
      window.removeEventListener("message", oauthCbk);
    }
  };
  window.addEventListener("message", oauthCbk);
};

connectedEmailUtils.microsoftAuth = async () => {
  const { noOfInboxesUsed = 0 } = userDetail?.userFeatureFlag || {};
  const {
    outlookClientId = "",
    outlookRedirectUrl = "",
    outlookScopes = ""
  } = connectedInboxStore.oAuthConfigs || {};

  if (InboxUtils.connectInboxAllowed()) {
    DriverMaster.killDriver();
    const authUrl =
      "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?" +
      "client_id=" +
      outlookClientId +
      "&response_type=code" +
      "&redirect_uri=" +
      outlookRedirectUrl +
      "&response_mode=query" +
      "&scope=" +
      outlookScopes +
      "&state=12345" +
      "&consent=prompt";
    const w = 600;
    const h = 800;
    const left = window.screen.width / 2 - w / 2;
    const top = window.screen.height / 2 - h / 2;
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`;
    const oAuthWindow = window.open(authUrl, "Salesgear", params);
    const oauthSuccess = async ev => {
      let {
        code = "",
        type = "",
        inboxId = "",
        connectedInbox = {},
      } = ev.data || ev.key;
      if (type === "MICROSOFT_CONNECT_INBOX") {
        switch (code) {
          case "200":
          case 200:
            userDetail.setUserFeatureFlag({
              ...userDetail.userFeatureFlag,
              noOfInboxesUsed: noOfInboxesUsed + 1
            });
            connectedInboxStore.setLoading(true);
            await connectedInboxStore.getAccountDetails(true);
            oAuthWindow.close();
            Utils.getOnboardingData();
            Utils.trackOnboardingMixpanel("account_connected");
            if (inboxId && Object.keys(connectedInbox).length > 0) {
              await reconnectSequencePopupState.getAllCampaignSequences(inboxId, connectedInbox);
            }
            break;
          case "409":
          case 409:
            oAuthWindow.close();
            setTimeout(() => {
              toasterState.setToastMsg(
                `Failed. This inbox is already connected to a different SalesIntel account. Try with a different one.`,
                "fail"
              );
            }, 200);
            break;
          case "500":
          default:
            toasterState.setToastMsg(
              "Something went wrong. Please try again later",
              "fail"
            );
        }
      }
    };
    window.addEventListener("message", oauthSuccess);
  } else {
    upgradeMulitpleInbox();
  }
};

const upgradeMulitpleInbox = () => {
  const { planName = "", inFreePlan = false } =
    userDetail?.userFeatureFlag || {};
  let tempPlanName = planName?.toLowerCase();
  let inboxModel =
    inFreePlan || ["starter", "basic"].includes(tempPlanName)
      ? "multipleInbox"
      : ["pro", "unlimited", "growth"].includes(tempPlanName)
        ? "multipleInboxCustom"
        : "";

  inboxModel &&
    PaywallUtils.upgradeUtilsFunction(inboxModel, false, planName, inFreePlan);
};

export { connectedEmailUtils };
